// extracted by mini-css-extract-plugin
export default {"root":"UserInfo_root_FCMwR","name":"UserInfo_name_OmDi_","id":"UserInfo_id_jJFW4"};